import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import StepperWizard from 'components/Shared/StepperWizard';
import { Link } from 'react-router-dom';
import { setStep } from 'stores/utils/step/actions';
import { useDispatch, useSelector } from 'react-redux';
import hasProp from 'helpers/hasProp';
import { resetSelectedWorksheet } from 'stores/worksheet/actions';
import { resetSchedule } from 'stores/worksheet/schedule/actions';
import ScheduleTime from './ScheduleTime';
import ScheduleClass from './ScheduleClass';
import SchedulePreview from './SchedulePreview';

/**
 * @todo when the UI for empty cart questions done, use cartQuestions from reducer or other resources
 * @note client still not confirm whether cartQuestions is the data we will be use
 */

export default function ScheduleView() {
  const { t } = useTranslation(['create-assign-saved']);
  const dispatch = useDispatch();

  const {
    assignedClass,
    assignedGroup,
    assignedStudent,
    assignedPrivateGroup,
    assignedAdminGroup,
    assignedLevel
  } = useSelector(state => state.schedule);

  const hasAssignees =
    assignedClass.length > 0 ||
    assignedGroup.length > 0 ||
    assignedStudent.length > 0 ||
    assignedPrivateGroup.length > 0 ||
    (hasProp(assignedAdminGroup, 'ID') && assignedLevel !== '');

  const BackButton = (
    <Link
      to="/create-and-assign/saved-worksheet"
      className="btn btn-link question-cart-content__back"
    >
      &lt; {t(`create-assign-saved:scheduleWo.backList`, 'Back To List')}
    </Link>
  );

  useEffect(() => {
    return () => {
      dispatch(resetSelectedWorksheet());
      dispatch(resetSchedule());
    };
  }, [dispatch]);

  const onSelect = step => {
    let valid = false;
    switch (step) {
      case 3:
        if (hasAssignees) {
          valid = true;
        }
        break;
      default:
        valid = true;
        break;
    }
    if (valid) {
      dispatch(setStep(step));
    }
  };

  return (
    <div className="content content__inner content__inner-create-assign">
      <StepperWizard
        backButton={BackButton}
        onSelect={onSelect}
        className="stepper-blue stepper-schedule stepper-default"
      >
        <ScheduleTime
          step="1"
          title={t(`create-assign-saved:scheduleWo.schedTime`, 'Schedule Time')}
        />
        <ScheduleClass
          step="2"
          title={t(
            `create-assign-saved:scheduleWo.schedClass`,
            'Schedule Class'
          )}
        />
        <SchedulePreview
          step="3"
          title={t(
            `create-assign-saved:scheduleWo.schedPrev`,
            'Schedule Preview'
          )}
        />
      </StepperWizard>
    </div>
  );
}
